import defaultTheme from 'tailwindcss/defaultTheme';
const transitions = {
    transitionDuration: {
        ...defaultTheme.transitionDuration,
        1200: '1200ms'
    },
    transitionProperty: {
        ...defaultTheme.transitionProperty,
        strokeDasharray: 'stroke-dasharray'
    }
};
export default transitions;
